import LegalLayout from './landing/LegalLayout';

function TermsOfService() {
  return (
    <LegalLayout title="Terms of Service">
      <section>
        <h2>Introduction</h2>
        <p>
          Welcome to EFSoft&apos;s Terms of Service. These terms govern your use
          of our software development services and constitute a legally binding
          agreement between you and EFSoft.
        </p>
      </section>

      <section>
        <h2>Service Description</h2>
        <p>EFSoft provides:</p>
        <ul>
          <li>Custom web application development</li>
          <li>Software consulting and architecture design</li>
          <li>Healthcare, finance, and e-commerce solutions</li>
          <li>Technical support and maintenance services</li>
        </ul>
      </section>

      <section>
        <h2>Contact Us</h2>
        <p>
          If you have any questions about these Terms, please contact us at:{' '}
          <a href="mailto:support@efsoft.com">support@efsoft.com</a>
        </p>
      </section>
    </LegalLayout>
  );
}

export default TermsOfService;
